import { createContext, FC, ReactNode, useContext } from "react"
import { useCreation } from "../../utils/reactHelpers/useCreation"
import AuthStore from "./AuthStore"

const AuthStoreContext = createContext<AuthStore | null>(null)

export const AuthStoreProvider: FC<{
  children: ReactNode
}> = props => {
  const store = useCreation(() => new AuthStore(), [])
  return (
    <AuthStoreContext.Provider value={store}>
      {props.children}
    </AuthStoreContext.Provider>
  )
}

export const useAuthStore = (): AuthStore => {
  const store = useContext(AuthStoreContext)
  if (store == null) {
    throw new Error("useAuthStore must be used within a AuthStoreProvider")
  }
  return store
}
